<template>
  <div class="content-area-wrap">
    <el-row class="content-area">
      <el-col :span="24" class="header">
        <el-row>
          <el-col :span="12">功能</el-col>
          <el-col :span="12">快捷键</el-col>
        </el-row>
      </el-col>
      <el-col :span="24" class="content">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="12">撤销</el-col>
              <el-col :span="12">Ctrl+Z</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">重做</el-col>
              <el-col :span="12">Ctrl+Y</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">添加</el-col>
              <el-col :span="12">Ctrl+[</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">删除</el-col>
              <el-col :span="12">Ctrl+]</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">合并</el-col>
              <el-col :span="12">Ctrl+G</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">拆分</el-col>
              <el-col :span="12">Ctrl+Alt+G</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">查找替换</el-col>
              <el-col :span="12">Ctrl+F</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">调换</el-col>
              <el-col :span="12">Ctrl+I</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">去重</el-col>
              <el-col :span="12">Ctrl+L</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">保存</el-col>
              <el-col :span="12">Ctrl+M</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">全部删除</el-col>
              <el-col :span="12">Ctrl+Delete</el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "KeyboardShortcut",
}
</script>
<style lang="scss" scoped>
.content-area {
  font-size: 12px;
  padding: 0 20px;
  min-width: 320px;

  .header {
    line-height: 28px;
    font-weight: bold;
  }

  .content {
    line-height: 30px;
  }
}
</style>